<template>
  <v-sheet :class="!styleTheme ? 'ma-3' : null" :color="styleTheme ? 'grey' : 'transparent'">
    <v-autocomplete
      v-model="customer"
      label="Müşteri"
      placeholder="Müşteri Seçin"
      persistent-placeholder
      :items="customerItems"
      :loading="customerLoading"
      :filled="styleTheme"
      :background-color="styleTheme ? 'grey' : 'transparent'"
      color="black"
      hide-details
      :rounded="styleTheme"
      item-text="company"
      item-value="customer_id"
      @change="customerChange"
    >
      <template v-if="!$vuetify.breakpoint.mdAndDown" v-slot:prepend>
        <v-icon>{{ icons.mdiDomain }}</v-icon>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title class="company-name">
            {{ item.company }}
          </v-list-item-title>
          <v-list-item-subtitle class="company-subtitle">
            {{ item.customer_id }}
          </v-list-item-subtitle>
          <v-list-item-subtitle class="company-subtitle">
            {{ item.office_desc || 'Ofis Bilgisi Yok' }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </v-sheet>
</template>

<script>
import store from '@/store'
import { showAppSnackbar } from '@/utils/showSnackbar'
import axios from '@axios'
import { mdiDomain } from '@mdi/js'
import { nextTick, onMounted, ref } from '@vue/composition-api'

const isRequestError = data => {
  if (!data || data.error == null || data.error === false || data.error === 0) {
    return false
  }

  return true
}

const normalizeCustomerId = value => (value == null ? null : String(value).trim())

export default {
  props: {
    styleTheme: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const customer = ref(null)
    const customerItems = ref([])
    const customerLoading = ref(false)
    const ignoreCustomerChange = ref(false)

    onMounted(() => {
      customerLoading.value = true

      const params = new URLSearchParams()
      params.append('method', 'getCustomersList')
      axios
        .post('', params)
        .then(response => {
          customerItems.value = response.data.detail
          customer.value = store.state.plasiyerCustomer
        })
        .catch(e => {
          showAppSnackbar(e.message, 'error')
        })
        .finally(() => {
          customerLoading.value = false
        })
    })

    const clearCustomerSelection = async () => {
      ignoreCustomerChange.value = true
      customer.value = null
      store.commit('PLASIYER_CUSTOMER', null)

      const baseToken = localStorage.getItem('salespersonBaseToken')
      if (baseToken) {
        localStorage.setItem('accessToken', baseToken)
      }

      await nextTick()
      ignoreCustomerChange.value = false
    }

    const customerChange = () => {
      if (ignoreCustomerChange.value || !customer.value) {
        return
      }

      const selectedCustomerId = customer.value

      customerLoading.value = true

      const params = new URLSearchParams()
      params.append('method', 'changeActiveCustomer')
      params.append('customer_id', selectedCustomerId)
      axios
        .post('', params)
        .then(async response => {
          if (isRequestError(response.data)) {
            await clearCustomerSelection()
            store.commit('SECOND_STATE', false)
            store.commit('SECOND_MSG', response.data.msg)
            showAppSnackbar(response.data.msg, 'warning')

            return
          }

          const matchedCustomer = customerItems.value.find(
            item => normalizeCustomerId(item.customer_id) === normalizeCustomerId(selectedCustomerId),
          )

          const activeCustomerId = matchedCustomer ? matchedCustomer.customer_id : selectedCustomerId
          store.commit('PLASIYER_CUSTOMER', activeCustomerId)
          customer.value = activeCustomerId

          if (response.data.accessToken) {
            localStorage.setItem('accessToken', response.data.accessToken)
          }
        })
        .catch(async e => {
          await clearCustomerSelection()
          showAppSnackbar(e.message || 'Müşteri seçimi yapılamadı.', 'error')
        })
        .finally(() => {
          customerLoading.value = false
        })
    }

    return {
      customerItems,
      customerLoading,
      customer,
      customerChange,
      icons: { mdiDomain },
    }
  },
}
</script>
<style lang="scss">
.v-menu__content:not(.list-style) .v-list-item {
  height: auto !important;
}

.company-name {
  font-size: 1rem;
  font-weight: bold;
  color: black;
}

.company-subtitle {
  font-size: 0.8rem;
  color: black;
}

@media (max-width: 600px) {
  .company-name {
    font-size: 0.875rem;
  }
  .company-subtitle {
    font-size: 0.75rem;
  }
}
</style>
